import { NavLink } from "react-router-dom";
import { useAuth } from "../../AuthContext";
import sideMenuList from "../Enums/sideBarMenu";
import { useDashboardQuery } from "../../redux/adminApi";

export default function Sidebar({ open, onClose }) {
  const { me, can } = useAuth();
  const { data } = useDashboardQuery(30, { skip: !can("dashboard"), pollingInterval: 120000 });
  const counts = data?.summary || {};
  const allowed = (item) => (item.perms.includes("owner") ? me?.is_owner : can(...item.perms));
  return (
    <>
      {open ? <div className="side-backdrop" onClick={onClose} /> : null}
      <aside className={`sidebar ${open ? "open" : ""}`} aria-label="Admin navigation">
        <div className="side-brand">
          <img src="/assets/images/logo-mark.png" alt="" />
          <div>
            <span>ZILLIONAIRE</span>
            <small>Store admin</small>
          </div>
        </div>
        <nav className="side-nav">
          {sideMenuList.map((g, gi) => {
            const items = g.items.filter(allowed);
            if (!items.length) return null;
            return (
              <div className="side-group" key={gi}>
                {g.group ? <p>{g.group}</p> : null}
                {items.map((item) => (
                  <NavLink key={item.route} to={item.route} className={({ isActive }) => `side-link ${isActive ? "active" : ""}`} onClick={onClose}>
                    <i className={`bi ${item.icon}`} aria-hidden="true" />
                    {item.title}
                    {item.badge && counts[item.badge] ? <span className="side-count">{counts[item.badge]}</span> : null}
                  </NavLink>
                ))}
              </div>
            );
          })}
        </nav>
      </aside>
    </>
  );
}
